import Departments from './Departments';
import EdenRedHeader from '@pages/NewHrModuleSetup/Component/EdenRedHeader/EdenRedHeader';
import React from 'react';
import './index.scss';

const DepartmentsPage = () => {
	return (
		<main className="wrapper">
			<EdenRedHeader />
			<div className="main-container">
				<Departments navigate="/new-hr-features/upload-leave" CleverTap={false} />
			</div>
		</main>
	);
};

export default DepartmentsPage;
